import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "position-header" }
const _hoisted_2 = { class: "position-title" }
const _hoisted_3 = {
  key: 0,
  class: "position-priority"
}
const _hoisted_4 = { class: "position-company" }
const _hoisted_5 = { class: "position-details" }
const _hoisted_6 = {
  key: 0,
  class: "position-salary"
}
const _hoisted_7 = {
  key: 1,
  class: "position-work-type"
}
const _hoisted_8 = { class: "position-status" }
const _hoisted_9 = {
  key: 0,
  class: "position-deadline"
}

import { computed } from 'vue';
import type { PropType } from 'vue';
import type { Position } from '@/types/position';
import { WORK_TYPE_OPTIONS, PRIORITY_OPTIONS } from '@/types/position';
import ApplicationStatusTag from './ApplicationStatusTag.vue';
import { Calendar } from '@element-plus/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PositionItem',
  props: {
  position: {
    type: Object as PropType<Position>,
    required: true
  }
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleClick = () => {
  emit('click', props.position);
};

const getWorkTypeLabel = (type: string) => {
  const option = WORK_TYPE_OPTIONS.find(opt => opt.value === type);
  return option ? option.label : type;
};

const getPriorityLabel = (priority: number) => {
  const option = PRIORITY_OPTIONS.find(opt => opt.value === priority);
  return option ? option.label : priority;
};

const getPriorityType = (priority: number) => {
  if (priority >= 4) return 'danger';
  if (priority >= 3) return 'warning';
  if (priority >= 2) return 'success';
  return 'info';
};

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('zh-CN', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    class: "position-item",
    shadow: "hover",
    onClick: handleClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.position.title), 1),
        (__props.position.priority)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_tag, {
                type: getPriorityType(__props.position.priority),
                size: "small",
                effect: "plain"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getPriorityLabel(__props.position.priority)), 1)
                ]),
                _: 1
              }, 8, ["type"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(__props.position.company?.name || ''), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (__props.position.minSalary && __props.position.maxSalary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.position.minSalary) + "-" + _toDisplayString(__props.position.maxSalary) + " " + _toDisplayString(__props.position.salaryCurrency || 'CNY'), 1))
          : _createCommentVNode("", true),
        (__props.position.workType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_tag, {
                size: "small",
                effect: "plain"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getWorkTypeLabel(__props.position.workType)), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(ApplicationStatusTag, {
          status: __props.position.applicationStatus,
          size: "small"
        }, null, 8, ["status"]),
        (__props.position.deadline)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_tooltip, {
                content: "截止日期",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "el-icon-time" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(formatDate(__props.position.deadline)), 1)
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})